import { render } from "./FormAuth.vue?vue&type=template&id=4b87790a&scoped=true"
import script from "./FormAuth.vue?vue&type=script&lang=js"
export * from "./FormAuth.vue?vue&type=script&lang=js"

import "./FormAuth.vue?vue&type=style&index=0&id=4b87790a&scoped=true&lang=css"

import exportComponent from "D:\\Development\\javascript\\accounts-butago-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b87790a"]])

export default __exports__